'use client'

import { Stack, XStack, YStack } from '@mythical/ui'
import { EmblaOptionsType } from 'embla-carousel'
import AutoScroll from 'embla-carousel-auto-scroll'
import useEmblaCarousel from 'embla-carousel-react'
import { MarqueeProps } from './MarqueeProps'

const Marquee = <T,>({
  items,
  renderItem,
  containerProps,
  scrollDirection = 'forward',
  keyExtractor,
  spacing = 0,
  emblaOptions,
  ...props
}: MarqueeProps<T>) => {
  const [emblaRef] = useEmblaCarousel(
    {
      loop: true,
      skipSnaps: true,
      align: 'start',
      ...emblaOptions,
    },
    [
      AutoScroll({
        direction: scrollDirection,
        playOnInit: true,
        speed: 0.5,
        stopOnInteraction: false,
        stopOnMouseEnter: false,
        stopOnFocusIn: false,
      }),
    ],
  )

  return (
    <Stack pos="relative" flex={1} ml={spacing * -1} ref={emblaRef} {...props}>
      <XStack
        touchAction="pan-y"
        style={{ backfaceVisibility: 'hidden' }}
        height="auto"
        {...containerProps}
      >
        {items.map((item, index) => (
          <YStack
            key={keyExtractor(item, index)}
            minWidth={0}
            flexGrow={0}
            flexShrink={0}
            flexBasis="auto"
            pl={spacing}
          >
            {renderItem(item, index)}
          </YStack>
        ))}
      </XStack>
    </Stack>
  )
}

Marquee.displayName = 'Marquee'

export { Marquee }
